import React from "react";
import {Alert, Snackbar, SnackbarCloseReason} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../store/store";
import {clearSnackbar} from "../../store/slices/snackbar.slice";

export function MaiSnackbar() {
    const dispatch = useDispatch();
    const {snackbarOpen, snackbarMessage, snackbarSeverity} = useSelector((state: RootState) => state.snackbar);

    const handleClose = (
        event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        dispatch(clearSnackbar())
    };

    return (
        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleClose}>
            <Alert
                onClose={handleClose}
                severity={snackbarSeverity}
                variant="filled"
                sx={{
                    width: '100%' ,
                }}
            >
                {snackbarMessage}
            </Alert>
        </Snackbar>
    )
}